// Chakra imports
import { useColorModeValue,Heading ,Text, Image, Grid, Box } from "@chakra-ui/react";
import Card from "components/Card/Card";
import CardBody from "components/Card/CardBody";
import CardHeader from "components/Card/CardHeader";
import React, {useState} from "react";
import {individualCalculatorOverViewF} from "../../../../variables/general";
import img from "assets/img/IndividualCalculator.jpg";


const IndividualCountry = () => {
  return (
    <Card mb="10px">
      <CardHeader>
        <Heading as='h3' size='lg'>Individual Calculator</Heading>
      </CardHeader>
      <CardBody>
        <Grid
          mt='30px'
          templateColumns={{ sm: "1fr", lg: "0.4fr 1.6fr" }}
          templateRows={{ sm: "1fr", lg: "1fr" }}
          gap='24px'>
            <Image src={img} alt='img2'/>
            <Box>
              <Text mb='5px'>{individualCalculatorOverViewF}</Text>
              <Text>The estimated milk volume is similar across countries. The only difference is the exchange rate.</Text>
            </Box>
        </Grid>
      </CardBody>
    </Card>
  );
};

export default IndividualCountry;
